import { useLocation } from "react-router-dom";
import { Languages } from "types/localization";
import { makeLangUrl } from "./makeLangUrl";

export const isArray = (i) => Array.isArray(i);
export const isObject = (i) =>
  typeof i === "object" && i !== null && !isArray(i);

export const isUrlActive = (url) => {
  const currentUrl = makeLangUrl(url);
  if (url === "") {
    return false;
  }
  const location = useLocation();
  if (location.search) {
    return (
      `${location.pathname.toLowerCase()}${location.search.toLowerCase()}` ===
      currentUrl.toLowerCase()
    );
  }
  return location.pathname.toLowerCase() === currentUrl.toLowerCase();
};

export const isUrlInclude = (url) => {
  if (url === "") {
    return false;
  }
  const location = useLocation();

  if (url === "/") {
    return location.pathname.toLowerCase() === url.toLowerCase();
  }
  if (location.search) {
    return `${location.pathname.toLowerCase()}${location.search.toLowerCase()}`.includes(
      url.toLowerCase(),
    );
  }
  return location.pathname.toLowerCase().includes(url.toLowerCase());
};

export const isAvailableLang = (lang: string): boolean => {
  return Object.keys(Languages).includes(lang.toUpperCase());
};
